import Vue from 'vue'
let MyPlugin = {}
// 定义全局指令
export default MyPlugin.install = function (vue, options) {
  // preventClick 是定义的指令 名称 ， 使用时 用 v-preventClick = "dosomethingFun or data"
  Vue.directive('preventClick', {
    // bind只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置
    inserted(button, bind) {
      button.addEventListener('click', () => {
        if (!button.disabled) {
          button.disabled = true;
          setTimeout(() => {
            button.disabled = false
          },1000)
        }
      })
    }
  })
}


// WEBPACK FOOTER //
// ./src/preventClick.js